import React, { createContext, useState, useCallback, useMemo } from 'react';
import { ClusterModalContextType, PhenomenonIdTuple } from '../clusterModal.models';
import { useDisclosure } from '../../../hooks/useDisclosure';
import ClusterModal from '../clusterModal';

export const ClusterModalContext = createContext<ClusterModalContextType | undefined>(undefined);

export function ClusterModalProvider({ children }: { children: React.ReactNode }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [phenomenonIds, setPhenomenonIds] = useState<PhenomenonIdTuple | undefined>(undefined);

  const onOpenClusterModal = useCallback(
    (phenomenonIdTuple: PhenomenonIdTuple) => {
      setPhenomenonIds(phenomenonIdTuple);
      onOpen();
    },
    [onOpen]
  );

  const onCloseClusterModal = useCallback(() => {
    setPhenomenonIds(undefined);
    onClose();
  }, [onClose]);

  const value = useMemo(
    () => ({
      isClusterModalOpen: isOpen,
      currentPhenomenonIds: phenomenonIds,
      onOpenClusterModal,
      onCloseClusterModal
    }),
    [isOpen, phenomenonIds, onOpenClusterModal, onCloseClusterModal]
  );

  return (
    <ClusterModalContext.Provider value={value}>
      {children}
      {phenomenonIds && <ClusterModal phenomenonIds={phenomenonIds} isVisible={isOpen} onClose={onCloseClusterModal} />}
    </ClusterModalContext.Provider>
  );
}
